import { render } from "./FilterSidebarSkeleton.vue?vue&type=template&id=61efa7e2"
import script from "./FilterSidebarSkeleton.vue?vue&type=script&lang=js"
export * from "./FilterSidebarSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__